import { Driver, Customer } from 'data-layer-cr/dist/models';

/**
 * Returns true if there is a mismatch in the customer's data vs the driver's data
 *
 * @param driver - The driver to check
 * @param customer - The customer to check
 */
export default function driverAndCustomerAreDifferent(
  driver: Driver,
  customer: Customer,
): boolean {
  return (
    driver.firstName != null &&
    driver.lastName != null &&
    (driver.firstName !== customer.firstName ||
      driver.lastName !== customer.lastName ||
      driver.birthday !== customer.birthday ||
      driver.gender !== customer.gender)
  );
}
